import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
import { AlertasModales } from '../../../helpers/alertasModales';
declare const CKEDITOR: any;

@Component({
  selector: 'app-pagare-notarial',
  templateUrl: './pagare-notarial.component.html',
  styleUrls: ['./pagare-notarial.component.css']
})
export class PagareNotarialComponent implements OnInit {
  @ViewChild('pdf') pdf: ElementRef;
  @ViewChild('bodyPdf') bodyPdf: ElementRef;
  @ViewChild('headerPdf') headerPdf: ElementRef;
  @ViewChild('footerPdf') footerPdf: ElementRef;
  form: FormGroup;
  loading = false;
  isEditing = true;
  ckeditorHasErrror = false;
  comandos: Array<any> = [];
  pdfContent: string;
  ckeditorValue: any;
  // tslint:disable-next-line:max-line-length
  constructor(private empleadoService: EmpleadosServicio, private configuracionesService: ConfiguracionesService, private modals: AlertasModales) {
    this.initCommands();
    this.initForm();
  }

  ngOnInit() {
  }

  private initCkeditor() {
    CKEDITOR.replace('editor2', {
      height: 1390
    });
  }

  pagarePreview() {
    this.ckeditorValue = CKEDITOR.instances.editor2.getData();
    if (!this.ckeditorValue) {
      this.ckeditorHasErrror = true;
      return false;
    }
    this.ckeditorHasErrror = false;
    this.isEditing = !this.isEditing;
    this.pdfContent = this.restoreCkeditorContent();
  }

  private initCommands() {
    const comandos = {
      notario: 'Atajo para insertar el nombre del notario.',
      cedulaNotario: 'Atajo para insertar la cédula del notario.',
      direccionNotario: 'Atajo para insertar el nombre del notario.',
      matriculaNotario: 'Atajo para insertar el nombre del notario.',
      empresa: 'Atajo para insertar el nombre de la empresa.',
      rncEmpresa: 'Atajo para insertar el rnc de la empresa.',
      direccionEmpresa: 'Atajo para insertar el rnc de la empresa.',
      acreedor: 'Atajo para insertar el nombre del acreedor.',
      cedulaAcreedor: 'Atajo para insertar la cédula del acreedor.',
      direccionAcreedor: 'Atajo para insertar la dirección del acreedor.',
      testigo1: 'Atajo para insertar el nombre del testigo 1.',
      cedulaTestigo1: 'Atajo para insertar la cédula del testigo 1.',
      testigo2: 'Atajo para insertar el nombre del testigo 2.',
      cedulaTestigo2: 'Atajo para insertar la cédula del testigo 2.',
      cliente: 'Atajo para insertar el nombre completo del cliente.',
      cedulaCliente: 'Atajo para insertar la cédula del cliente.',
      direccionCliente: 'Atajo para insertar la dirección del cliente.',
      montoPrestamo: 'Atajo para insertar el capital + interes del préstamo.',
      totalCuotas: 'Atajo para insertar el total de cuotas del préstamo.',
      montoCuota: 'Atajo para insertar el monto de cuota del préstamo.',
      primeraFechaPago: 'Atajo para insertar la fecha del primer pago de la cuota.',
      ultimaFechaPago: 'Atajo para insertar la fecha del último pago de la cuota.',
      formaPago: 'Atajo para insertar la forma de pago del préstamo (SEMANAL, QUINCENAL, etc).',
      plazo: 'Atajo para insertar el plazo del préstamo (QUINCE (15) días, etc).',
      fechaPrestamo: 'Atajo para insertar la fecha del préstamo.'
    };

    // tslint:disable-next-line:forin
    for (const k in comandos) {
      this.comandos.push({
        key: `#${k}#`,
        value: comandos[k]
      });
    }
  }

  private initForm(): void {
    this.form = new FormGroup({
      ID_EMPLEADO: new FormControl(this.empleadoService.datosEmpleado.ID_EMPLEADO),
      notario: new FormControl('', Validators.required),
      cedulaNotario: new FormControl('', Validators.required),
      direccionNotario: new FormControl('', Validators.required),
      matriculaNotario: new FormControl('', Validators.required),
      empresa: new FormControl(''),
      rncEmpresa: new FormControl(''),
      direccionEmpresa: new FormControl(''),
      acreedor: new FormControl('', Validators.required),
      cedulaAcreedor: new FormControl('', Validators.required),
      direccionAcreedor: new FormControl('', Validators.required),
      testigo1: new FormControl('', Validators.required),
      cedulaTestigo1: new FormControl('', Validators.required),
      testigo2: new FormControl('', Validators.required),
      cedulaTestigo2: new FormControl('', Validators.required),
      pagare_html: new FormControl('', Validators.required),
      cliente: new FormControl('Nombre Cliente Aquí'),
    });

    this.form.get('cliente').disable();
    this.initPagare();
  }

  private restoreCkeditorContent(): string {
    let pdfContent = this.ckeditorValue;

    if (pdfContent) {
      for (const row of this.comandos) {
        for (const keyForm of Object.keys(this.form.controls)) {
          if (row.key === `#${keyForm}#` && this.form.get(keyForm).value) {
            const regExp = new RegExp(row.key, 'g');
            pdfContent = pdfContent.replace(regExp, this.form.get(keyForm).value);
          }
        }
      }
    }

    return pdfContent;
  }

  previewLive() {
    this.pdfContent = this.restoreCkeditorContent();
  }

  actualizarConfiguracion() {
    if (CKEDITOR.instances.editor2.getData() && !this.loading && this.form.valid) {
      this.loading = true;
      this.form.get('pagare_html').setValue(CKEDITOR.instances.editor2.getData());

      this.configuracionesService.actualizarPagare(this.form.value)
      .subscribe(res => {
        setTimeout(() => this.loading = false, 1);
        if (res) {
          this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-gear');
        }
      }, err => {
        setTimeout(() => this.loading = false, 1);
        if (err) {
          if ((err.hasOwnProperty('status') && err.status === 0) ||
          (err.hasOwnProperty('name') && err.name === 'TimeoutError')) {
            this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
              'orange',
              'modern',
              false,
              'fa fa-wifi');
          } else {
            this.modals.validacionesModalJquery('Ha ocurrido un error inesperado', err, 'red', 'modern');
          }
        }
      });
    }
  }

  private initPagare() {
    this.configuracionesService.pagareNotarial()
    .subscribe((res: any) => {
      const form = this.form;
      if (res) {
        form.get('notario').setValue(res.notario);
        form.get('cedulaNotario').setValue(res.cedulaNotario);
        form.get('direccionNotario').setValue(res.direccionNotario);
        form.get('matriculaNotario').setValue(res.matriculaNotario);
        form.get('empresa').setValue(res.empresa);
        form.get('rncEmpresa').setValue(res.rncEmpresa);
        form.get('direccionEmpresa').setValue(res.direccionEmpresa);
        form.get('acreedor').setValue(res.acreedor);
        form.get('cedulaAcreedor').setValue(res.cedulaAcreedor);
        form.get('direccionAcreedor').setValue(res.direccionAcreedor);
        form.get('testigo1').setValue(res.testigo1);
        form.get('cedulaTestigo1').setValue(res.cedulaTestigo1);
        form.get('testigo2').setValue(res.testigo2);
        form.get('cedulaTestigo2').setValue(res.cedulaTestigo2);
        form.get('pagare_html').setValue(res.pagare_html);
        this.initCkeditor();
      } else {
        this.initCkeditor();
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/configuraciones/pagare-notarial/pagare-notarial.component.ts